export const HeaderData_EN =
{
	"jcr:primaryType": "cq:PageContent",
	"jcr:createdBy": "admin",
	"title": "header-page",
	"cq:template": "/apps/gdocs/templates/page-create-case",
	"jcr:language": "en",
	"cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
	"jcr:created": "Thu Feb 07 2019 12:34:11 GMT+0000",
	"cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
	"cq:cloudserviceconfigs": ["[]"],
	"sling:resourceType": "gdocs/components/pages/create-case",
	"cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
	"cq:lastModifiedBy": "admin",
	"par": {
		"jcr:primaryType": "nt:unstructured",
		"sling:resourceType": "wcm/foundation/components/parsys",
		"static_text_darkTitleBar": {
			"jcr:primaryType": "nt:unstructured",
			"jcr:createdBy": "admin",
			"SkipToMainContent": "Skip to main content",
		}
	}
}

export const HeaderData_ES =
{
	"jcr:primaryType": "cq:PageContent",
	"jcr:createdBy": "admin",
	"title": "header-page",
	"cq:template": "/apps/gdocs/templates/page-create-case",
	"jcr:language": "en",
	"cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
	"jcr:created": "Thu Feb 07 2019 12:34:11 GMT+0000",
	"cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
	"cq:cloudserviceconfigs": ["[]"],
	"sling:resourceType": "gdocs/components/pages/create-case",
	"cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
	"cq:lastModifiedBy": "admin",
	"par": {
		"jcr:primaryType": "nt:unstructured",
		"sling:resourceType": "wcm/foundation/components/parsys",
		"static_text_darkTitleBar": {
			"jcr:primaryType": "nt:unstructured",
			"jcr:createdBy": "admin",
			"SkipToMainContent": "Saltar al contenido principal",
		}
	}
}

export const HeaderData_BA =
{
	"jcr:primaryType": "cq:PageContent",
	"jcr:createdBy": "admin",
	"title": "header-page",
	"cq:template": "/apps/gdocs/templates/page-create-case",
	"jcr:language": "en",
	"cq:contextHubSegmentsPath": "/etc/segmentation/contexthub",
	"jcr:created": "Thu Feb 07 2019 12:34:11 GMT+0000",
	"cq:lastModified": "Wed Oct 25 2017 14:28:20 GMT+0000",
	"cq:cloudserviceconfigs": ["[]"],
	"sling:resourceType": "gdocs/components/pages/create-case",
	"cq:contextHubPath": "/etc/cloudsettings/default/contexthub",
	"cq:lastModifiedBy": "admin",
	"par": {
		"jcr:primaryType": "nt:unstructured",
		"sling:resourceType": "wcm/foundation/components/parsys",
		"static_text_darkTitleBar": {
			"jcr:primaryType": "nt:unstructured",
			"jcr:createdBy": "admin",
			"SkipToMainContent": "Langsung ke konten utama",
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/layouts/Header/ContentLink.js